import { initNav } from '../components/nav';

// Initialize navigation modal
initNav();
